export const VALIDATION_RULES = {
  PASSWORD: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{10,}$/,
  PASSWORD_NOT_INCLUDE_SYMBOL: /^[^!-/:-@[-`{-~]*$/, // 記号を検知するための正規表現
  NUMERIC_ONLY: /^(0|[1-9]\d*)(\.\d+)?$/,
  PHONE_NUMBER: /^0\d{9,10}$/,
  PUBLIC_DOMAIN_ALPHA_NUMERIC_INCLUDE_HYPHEN_ONCE: /^[a-z0-9]+(-[a-z0-9]+)?$/,
  PUBLIC_DOMAIN_DISALLOW_EDGE_HYPHEN: /^[^-].*[^-]$/,
  URL: /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i,
  MUNICIPALITY: /^[a-zA-Z0-9\u3040-\u30FF\u4E00-\u9FAF\uFF66-\uFF9F\uFF10-\uFF19]+$/,
  HIRAGANA: /^([\u3040-\u309f\u3000]|[、|・|ー])+$/i,
  // eslint-disable-next-line no-useless-escape
  TOWN: /^(?=.*[a-zA-Z0-9\u3040-\u30FF\u4E00-\u9FAF\uFF66-\uFF9F\uFF10-\uFF19])(?=.*[\-])[a-zA-Z0-9\u3040-\u30FF\u4E00-\u9FAF\uFF66-\uFF9F\uFF10-\uFF19\-]+$/,
  INVOICE_NUMBER: /^T\d{13}$/,
  MAX_SPACE: 9999,
  MAX_SIZE: 100000,
  MAX_FEE: 1000000,
  MAX_FREE_RENT: 12,
  MAX_STRING_LENGTH: 255,
  MAX_SPECIAL_TERMS_LENGTH: 1000,
  MAX_FILE_UPLOAD_SIZE: (20 * 1024 * 1024) as 20971520, // 20MB
  MAX_CONTRACT_PDF_SIZE: (5 * 1024 * 1024) as 5242880, // 5MB
  MAX_CONTRACT_PDF_SIZE_30MB: (30 * 1024 * 1024) as 31457280, // 30MB
  EMAIL: /^[a-zA-Z0-9]+(?:[._%+-][a-zA-Z0-9]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/i,
  NUMERIC_PLATE: /^(?:\d{1,5}|\d{2}-\d{2})$/i,
  NUMERIC_HYPHEN_ONLY: /^[0-9-]*$/,
  CONTRACTOR_NAME:
    // eslint-disable-next-line no-useless-escape, no-irregular-whitespace
    /[^\u4E00-\u9FFF\u3400-\u4DBF\u3000-\u303F\u3040-\u309F\u30A0-\u30FFヶヵ\u31F0-\u31FF々\u3005A-Za-z0-9０-９\s　ーｰ－\-・\(\)（）\uFF06\u3001\u2019\uFF0C\u002E\uFF0E]/g,
} as const;

// DOCS: https://docs.google.com/spreadsheets/d/1vOnES9kuemPMwcQX0bFCphBOE4gpNnl35DCVdZ6IsW8#gid=1425839050
export const VALIDATION_MESSAGE = {
  REQUIRED: "入力してください",
  ONE_OR_MORE: "ひとつ以上選択してください",
  INVALID_FORMAT_EMAIL: "メールアドレスをご確認ください",
  INVALID_FORMAT_EMAIL_WITH_EXAMPLE: "メール形式（xxx@xxx.xx）で入力してください",
  TOO_LARGE_STRING: (max = 255) => `${max}文字以内で入力してください`,
  WEAK_PASSWORD: "脆弱なパスワードです",
  PASSWORD_NOT_SYMBOL: "パスワードに記号は含めることができません",
  CURRENT_PASSWORD_REUSE: "現在のパスワードと同じパスワードを新しいパスワードに設定することはできません。",
  NOT_MATCH_PASSWORD: "パスワードが一致しません",
  MAX_FILE_UPLOAD_SIZE: "「20MB」以上のファイルはアップロード出来ません",
  MAX_CONTRACT_PDF_SIZE: "「5MB」以上のファイルはアップロード出来ません",
  MAX_CONTRACT_PDF_SIZE_30MB: "「30MB」以上のファイルはアップロード出来ません",
  INVALID_URL: "URLの形式が誤っています",
  MUST_AFTER_START_DATE: `利用終了日は利用開始日より後を選択してください`,
  INVALID_NUMBER: "正しい数値を入力してください",
  INVALID_PHONE_NUMBER: "電話番号をハイフンなしで正しい形式で入力してください",
  INVALID_PUBLIC_DOMAIN: "英小文字3文字以上30文字以内で入力してください",
  TOO_LARGE_NUMBER: (max: number) => `${max}以内で入力してください`,
  TOO_MANY_FILES: "アップロードできるファイルはひとつだけです",
  // 定義書にないメッセージ
  INVALID_ADDRESS_FORMAT: "番地をハイフンを含む形式で入力してください", // V027
  INVALID_ADDRESS_HYPHEN_OTHER_THAN_NUMBER:
    "住所の先頭または途中にハイフンが含まれています。ハイフンを削除してください。",
  INVALID_ADDRESS_POSTAL_CODE: "住所の先頭に郵便番号が含まれています。郵便番号を削除してください。",
  INVALID_ADDRESS_CHOUBANGOU_HANKAKU: "住所の丁番号は半角で入力してください",
  INVALID_INVOICE_NUMBER: "正しい形式で入力してください（例：T0123456789012）",
  INVALID_VALUE: "正しく入力してください",
  NOT_LOCK_MARKER: "ピンの位置を確認し、問題がなければチェックをつけてください",
  SELECT_MANAGER: "担当者を選択してください。",
  SELECT_PREFECTURE: "都道府県を選択してください。",
  SELECT_PROPERTY: "物件を選択してください。",
  SELECT_SPACE: "利用区画を選択してください。",
  SELECT_VEHICLE_SIZE: "車両サイズを選択してください。",
  REQUIRED_UPLOAD_FRONT_BACK: "表面と裏面の両方をアップロードしてください",
  PLEASE_SELECT_DATE_AFTER_TODAY: "本日以降の日付をご指定ください。",
  TOO_MANY_MEMBERS: "担当者は20名以内で選択してください",
} as const;
